<template>
  <div class="full-height" id="app">
    <component :is="layout" :videos=videos :loading=loading :deviceName=deviceName :qrcode=qrcode :controllerUrl=controllerUrl :exception=exception>
    </component>
  </div>
</template>

<script>
import LayoutV1 from "./components/LayoutV1"
import LayoutV2 from "./components/LayoutV2"
// import '../assets/semantic-ui/semantic.min.css'
import '../assets/semantic-ui/components/reset.min.css'
import '../assets/semantic-ui/components/site.min.css'
import '../assets/semantic-ui/components/grid.min.css'
import '../assets/semantic-ui/components/container.min.css'
import '../assets/semantic-ui/components/segment.min.css'
import '../assets/semantic-ui/components/message.min.css'
import '../assets/semantic-ui/components/icon.min.css'

export default {
  name: 'app',
  data () {
    return {
      loading: false,
      deviceName: undefined,
    };
  },
  computed: {
    videos () {
      return this.$store.state.videos;
    },
    qrcode () {
      return this.$store.state.qrcode;
    },
    controllerUrl () {
      return this.$store.state.controllerUrl;
    },
    exception () {
      return this.$store.state.exception;
    },
    layout () {
      if (this.$store.state.layout == 2) {
        return LayoutV2;
      }
      return LayoutV1;
    },
  },
  // Server-side only
  // This will be called by the server renderer automatically
  serverPrefetch () {
    // return the Promise from the action
    // so that the component waits before rendering
    const fetchVideos = this.fetchVideos()
      .then(() => {
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err, { stackt: err.stack, query: this.$ssrContext && this.$ssrContext.query });
        const { status, message, stack } = err;
        this.$store.commit('setException', { status, message, stack });
      });
    const generateQRCode = this.generateQRCode();
    return Promise.all([fetchVideos, generateQRCode]);
  },
  mounted () {
    if (this.qrcode == undefined) {
      this.generateQRCode();
    }
    if (this.videos == undefined) {
      this.loading = true;
      this.fetchVideos()
      .then(() => {
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err, err.stack);
        this.$store.commit('setException', err);
      })
      .then(() => this.loading = false);
    }
  },
  components: {
    LayoutV1,
    LayoutV2,
  },
  methods: {
    fetchVideos (params) {
      return this.$store.dispatch('fetchVideos', params);
    },
    generateQRCode () {
      return this.$store.dispatch('generateQRCode');
    },
  },
}
</script>

<style>
body {
  overflow: hidden;
  margin: 0;
  height: 100%;
  font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Microsoft JhengHei, Arial, sans-serif;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-color: black;
  margin: 0;
  padding: 0;
  color: white;
}
.full-height{
  height: 100%;
}
</style>
